import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchReviewEntries } from '../query-api'
import type { ReviewEntriesResponse } from '../types/reviewEntriesResponse'

interface UseFetchReviewEntriesProps {
  beginDate: string
  enabled?: boolean
  endDate: string
  page?: string
  pageSize?: string
}

// v1 has no pagination UI — request a larger page until pagination is added
const REVIEW_ENTRIES_DEFAULT_PAGE_SIZE = '100'

export const useFetchReviewEntries = ({
  beginDate,
  enabled = true,
  endDate,
  page = '1',
  pageSize = REVIEW_ENTRIES_DEFAULT_PAGE_SIZE,
}: UseFetchReviewEntriesProps) => {
  const { organization } = useUserOrganization()
  const organizationId = organization?.id

  const queryParams = useMemo(
    () => ({
      beginDate,
      endDate,
      organizationId: organizationId as string,
      page,
      pageSize,
    }),
    [beginDate, endDate, organizationId, page, pageSize],
  )

  const { data, ...rest } = useQuery<ReviewEntriesResponse>(
    [QueryKeys.ReviewEntries, queryParams],
    () => fetchReviewEntries(queryParams),
    {
      enabled: enabled && !!organizationId,
      staleTime: defaultStaleTime,
    },
  )

  return {
    reviewEntries: data,
    ...rest,
  }
}
